import { useTimeoutEffect } from '@react-hookz/web/useTimeoutEffect/index.js';
import type { DependencyList } from 'react';
import { useEffect } from 'react';

export function useDebounce(fn: () => void, ms: number = 0, deps: DependencyList = []): () => void {
	const [cancel, reset] = useTimeoutEffect(fn, ms);

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(reset, deps);

	return cancel;
}
